// extracted by mini-css-extract-plugin
module.exports = {"midterm-container":"MidtermPriceBox_midterm-container___hZdP"};